export default __webpack_public_path__ + "static/media/sinks.4182a447.png";